import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Wrapper = styled.div`
  display: flex;
  margin: 20px 0;
  span {
    font-family: ${({ theme }) => theme.default.fontFamily.secondaryFont};
    font-size: 13px;
    font-style: normal;
    font-weight: 900;
    line-height: 30px;
    letter-spacing: 0.05em;
    text-align: left;
  }
  .signed_out_wrapper{
    color: ${({ theme }) => theme.default.color.text.medium};
  }

  .event-login {
    text-transform: none;
  }
  @media (max-width: ${defaultBreakpoints.medium}) {
    flex-direction: column;
    margin: 0;
  }
`;

export const PostEventWrapper = styled.div`
    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.default.color.background};
    border-radius: 16px;
    padding: 24px;
    width: 100%;
    margin-top: 32px;

    @media (max-width: ${defaultBreakpoints.medium}) {
    margin-top: 24px;
    }

    button {
      margin: auto;
    }

    .event-login {
        background-color: ${({ theme }) => theme.default.color.primary};
        color: ${({ theme }) => theme.default.color.backgrounds.white};
        padding: 12px 15px;
        border-radius: 20px;
    }
`

export const Typography = styled.p`
  color: ${(props) => props.theme.default.color.primary};
  text-align: center;
  font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
  font-size: 12px;
  font-style: normal;
  font-weight: 800;
  line-height: 12px;
  text-transform: uppercase;
  margin: 0 0 12px 0;
`

export const Info = styled.p`
  font-family: ${({ theme }) => theme.default.fontFamily.secondaryFont};
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
  margin: 0 0 12px 0;

`
